import React from 'react';
import c from 'classnames';
import ModalLayout, { ModalLayoutProps } from '../../../Modal/ModalLayout';
import s from './VerticalLayout.scss';

interface Props
  extends Omit<ModalLayoutProps, 'footer' | 'content' | 'header'> {
  title: React.ReactNode;
  message?: React.ReactNode;
  image?: React.ReactNode;

  footerButtons: React.ReactNode[];
  footerExtras?: React.ReactNode;
  shouldStackFooterButtons?: boolean;

  className?: string;
}

const VerticalLayout: React.FC<Props> = ({
  image,
  title,
  message,
  className,
  footerButtons,
  footerExtras,
  shouldStackFooterButtons = false,
  ...rest
}) => (
  <ModalLayout
    className={c(s['root'], className)}
    footer={
      <div className={s['footer']}>
        <div
          className={c(
            s['footer-buttons'],
            shouldStackFooterButtons && s['footer-buttons-stacked']
          )}
        >
          {footerButtons}
        </div>
        <div className={s['footer-extras']}>{footerExtras}</div>
      </div>
    }
    content={
      <div className={s['content-root']}>
        {image && <div className={s['image']}>{image}</div>}
        <div className={s['title']}>{title}</div>
        {message && <div className={s['message']}>{message}</div>}
      </div>
    }
    {...rest}
  />
);
VerticalLayout.displayName = 'VerticalLayout';

export default VerticalLayout;
